<template>
    <popup-modal
        custom-classes="w-768"
        :title="$t('settings.interview-templates.new_template')"
        position="center"
        @close="closePopup(false)"
    >
        <div>
            <template
                v-if="!value">
                <new-module-template
                    :service="service()"
                    :template="value"
                    @input="$emit('input', $event)"
                />
            </template>
            <template
                v-else>
                <module-template-items
                    :service="service()"
                    v-if="value"
                    :template="value"
                />
            </template>

            <div class="flex items-center justify-end gap-8 mt-24">
                <simple-button @click="closePopup(false)">
                    {{ $t('general.cancel') }}
                </simple-button>
                <simple-button
                    :disabled="!value"
                    display="secondary"
                    look="primary"
                    @click="closePopup(true)"
                >
                    {{ $t('general.save') }}
                </simple-button>
            </div>
        </div>
    </popup-modal>
</template>


<script>
import PopupModal from "./ui/PopupModal.vue";
import ModuleTemplateItems from "./ModuleTemplateItems";
import NewModuleTemplate from "./applications/NewModuleTemplate";
import {mapState, mapActions} from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../state/store';
import SimpleButton from "./ui/SimpleButton.vue";

export default {
    components: {
        SimpleButton,
        PopupModal,
        ModuleTemplateItems,
        NewModuleTemplate
    },
    props: {
        service: {
            required: true,
            default: null
        },
        type: String,
        value: {
            required: true
        }
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
    },
    methods: {
        ...mapActions(useMainStore, ['setTemplateModuleInfo']),
        closePopup(confirm) {
            this.$emit('close', confirm);
        },
        setCompetenceTemplateModuleInfo() {
            this.setTemplateModuleInfo({
                templateModel: 'competence-templates',
                model: 'competences',
                type: 'competence',
                children: 'competences',
                autocomplete: true,
                hasPivot: true,
                pivot_id: 'competence_id',
                title: {
                    attribute: 'title',
                    locale: this.locale
                },
                text: {
                    title: this.$t('settings.competence-templates.title'),
                    sub_title: this.$t('competence-templates.your_competences'),
                    new_item: this.$t('competence-templates.new_competence'),
                    item_short: 'C',
                    no_items_found: this.$t('settings.competence-templates.no_competences')
                },
            });
        },
        setInterviewTemplateModuleInfo() {
            this.setTemplateModuleInfo({
                templateModel: 'interview-templates',
                model: 'questions',
                type: 'forum',
                children: 'questions',
                autocomplete: true,
                hasPivot: true,
                pivot_id: 'question_id',
                title: {
                    attribute: 'question',
                    locale: this.locale
                },
                text: {
                    title: this.$t('settings.interview-templates.title'),
                    sub_title: this.$t('settings.interview-templates.your_questions'),
                    new_item: this.$t('settings.interview-templates.new_question'),
                    item_short: 'Q',
                    no_items_found: this.$t('settings.interview-templates.no_questions')
                },
            });
        }
    },
    mounted() {
        if (this.type === 'competence-templates') this.setCompetenceTemplateModuleInfo();
        else if (this.type === 'interview-templates') this.setInterviewTemplateModuleInfo();
    }
}
</script>

<style scoped>

</style>
